/** Нормализация телефона для нативного `tel:` в Telegram WebView. */
export function crmTelHref(phone: string | null | undefined): string | null {
  const raw = String(phone ?? '').trim();
  if (!raw) return null;
  let digits = raw.replace(/[^\d+]/g, '');
  if (digits.startsWith('00')) digits = `+${digits.slice(2)}`;
  if (digits.startsWith('8') && digits.length === 11) digits = `+7${digits.slice(1)}`;
  if (digits.startsWith('7') && !digits.startsWith('+') && digits.length === 11) digits = `+${digits}`;
  const numeric = digits.replace(/\D/g, '');
  if (numeric.length < 10) return null;
  return digits.startsWith('+') ? `tel:${digits}` : `tel:+${numeric}`;
}
